import { Box, Flex, Image, useMediaQuery } from '@chakra-ui/react'
import logo from '../../../images/logotipo.png'
import { Link } from 'react-router-dom'
import { MenuItem } from './MenuItem'
import { LigacaoModal } from './Ligacao'
import { User } from './User'
import { HeaderMobile } from '../HeaderMobile'
import { WorkdayCalendar } from '../../WorkdayCalendar'
import { MeusChamadosButton } from './MeusChamadosButton'

export function HeaderCustomer({ menupai, menufilho, nomeUsuario, avatarUrl, hasTelefone }) {
  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)')
  const menuList = menupai
    .map((itemPai, index) => {
      const menuCreated = []

      menufilho.map((itemFilho, index) => {
        if (itemFilho.menupai === itemPai) {
          menuCreated.push(itemFilho)
        }

        return menuCreated
      })

      return {
        menupai: itemPai,
        menufilho: menuCreated,
      }
    })
    .filter((item) => item.menupai !== 'Home')

  return (
    <>
      <Box
        as="header"
        display={{ base: 'none', md: 'flex' }}
        alignItems="center"
        justifyContent="space-between"
        w="100%"
        py="2px"
        bgColor="#313E44"
        mx="auto"
      >
        <Flex w="100%" px="20px" mx="auto" maxW="1600px" alignItems="center" justifyContent="space-between">
          <Flex alignItems="center" gap={5}>
            <Link to="/">
              <Image
                w="100px"
                h="70px"
                objectFit="contain"
                src={'https://imgproductioncrm.s3.us-east-2.amazonaws.com/logo%20omnipromo-02.png1738267820.646'}
                alt="Logo"
              />
            </Link>

            <Flex alignItems="center" gap={4}>
              {menuList.map((menu, index) => (
                <MenuItem key={index} menuItem={menu} />
              ))}
            </Flex>
          </Flex>
          <Flex alignItems="center" gap={2} {...(isLargerThan1366 && { maxW: '250px' })}>
            {hasTelefone && <WorkdayCalendar />}

            {hasTelefone && <LigacaoModal />}
            <User userName={nomeUsuario} avatarUrl={avatarUrl} />
          </Flex>
        </Flex>
      </Box>

      <HeaderMobile nomeUsuario={nomeUsuario} menupai={menupai} menufilho={menufilho} avatarUrl={avatarUrl} />
    </>
  )
}
